module.exports = __webpack_public_path__ + "img/1.960f14ac.png";